import { createStyles, makeStyles, Tab, Tabs } from "@material-ui/core";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import { TabContainer } from "../types";

interface ITopTabProps {
    selected: string;
    onChange: (value: string) => void;
    tabs: TabContainer[];
}


const useStyles = makeStyles((theme: IYoelloTheme) =>
    createStyles({
        tabsStyle: {
            display: "flex",
            fontWeight: 600,
            color: `black !important`,
            '&$selected': {
                color: theme.palette.primary.contrastText,
            },
            '&:focus': {
                color: theme.palette.primary.contrastText,
            },
        },
    }),
);

export function TopTabs({
    selected,
    onChange,
    tabs
}: ITopTabProps) {
    const { tabsStyle } = useStyles();
    const { t } = useTranslation();
    const selectedPos = useMemo(() => {
        return tabs.findIndex((tab) => tab?.key === selected);
        //eslint-disable-next-line
    }, [selected]);

    function handleChange(event: React.ChangeEvent<{}>, position: number) {
        onChange(tabs[position].key);
    };

    function renderRows() {
        return tabs.map((tab) => {
            return <Tab
                className={tabsStyle}
                label={t(tab?.title!)} />
        })
    }

    return <Tabs
        value={selectedPos}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
        selectionFollowsFocus
    >
        {renderRows()}
    </Tabs>
}